"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFuzzyFilter = void 0;
/**
 * Usage example:
 *
 * const data = [
 *     { name: "John" },
 *     { name: "Paul" },
 *     { name: "George" },
 *     { name: "Ringo" },
 * ];
 *
 * useFuzzyFilter(data, "gerge", { keys: ["name"] }),
 * => { name: "George" }
 */
const react_1 = require("react");
const fuse_js_1 = __importDefault(require("fuse.js"));
const useDeepMemo_1 = require("./useDeepMemo");
function isString(str) {
    return str != null && typeof str.valueOf() === "string";
}
const isEmptySearch = (searchTerm) => {
    if (isString(searchTerm)) {
        return searchTerm.length === 0;
    }
    return Object.values(searchTerm).join("").length === 0;
};
const buildFuseSearchExpression = (searchTerm) => {
    if (isString(searchTerm)) {
        return searchTerm;
    }
    const searchEntries = Object.entries(searchTerm)
        .filter(([, value]) => value.trim().length)
        .map(([key, value]) => ({
        [key]: value,
    }));
    return {
        $and: searchEntries,
    };
};
const useFuzzyFilter = (data, searchTerm, options) => {
    const optionsMemo = (0, useDeepMemo_1.useDeepMemo)(options);
    const searchTermMemo = (0, useDeepMemo_1.useDeepMemo)(searchTerm);
    const fuseSearch = (0, react_1.useMemo)(() => {
        return new fuse_js_1.default(data, optionsMemo);
    }, [data, optionsMemo]);
    const searchResults = (0, react_1.useMemo)(() => {
        const searchExpression = buildFuseSearchExpression(searchTermMemo);
        return fuseSearch.search(searchExpression).map((result) => result.item);
    }, [fuseSearch, searchTermMemo]);
    return isEmptySearch(searchTermMemo) ? data : searchResults;
};
exports.useFuzzyFilter = useFuzzyFilter;
//# sourceMappingURL=useFuzzyFilter.js.map